(function () {
  const intervals = new Map();

  function initShippingCountdown(wrapper) {
    const wrapperId = wrapper.id;
    const suffix = wrapperId.replace('shipping-countdown-wrapper-', '');
    const timerEl = document.getElementById('shipping-countdown-timer-' + suffix);
    const textEl  = document.getElementById('shipping-countdown-text-' + suffix);
    if (!timerEl || !textEl) return;

    if (intervals.has(wrapperId)) {
      clearInterval(intervals.get(wrapperId));
      intervals.delete(wrapperId);
    }

    const cutoffRaw  = wrapper.dataset.cutoff;
    const productName = wrapper.dataset.productName || '';

    function parseCutoff(str) {
      const match = str.match(/(\d+):(\d+)\s*(AM|PM)/i);
      if (!match) return { hour: 15, min: 0 };
      let hour = parseInt(match[1], 10);
      const min  = parseInt(match[2], 10);
      const ampm = match[3].toUpperCase();
      if (ampm === 'PM' && hour !== 12) hour += 12;
      if (ampm === 'AM' && hour === 12) hour = 0;
      return { hour, min };
    }

    const { hour: cutoffHour, min: cutoffMin } = parseCutoff(cutoffRaw);

    function getNowPacific() {
      const parts = new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/Los_Angeles',
        year: 'numeric', month: 'numeric', day: 'numeric',
        hour: 'numeric', minute: 'numeric', second: 'numeric',
        hour12: false
      }).formatToParts(new Date());
      const p = {};
      parts.forEach(function(x) { p[x.type] = +x.value; });
      return new Date(p.year, p.month - 1, p.day, p.hour % 24, p.minute, p.second);
    }

    function getMondayCutoff(now) {
      const d = new Date(now);
      const day = d.getDay();
      const daysToMonday = day === 0 ? 1 : 8 - day;
      d.setDate(d.getDate() + daysToMonday);
      d.setHours(cutoffHour, cutoffMin, 0, 0);
      return d;
    }

    function tick() {
      const now = getNowPacific();
      const day = now.getDay(); // 0=Sun 1=Mon 2=Tue 3=Wed 4=Thu 5=Fri 6=Sat

      let shipText, diff;

      if (day === 5 || day === 6 || day === 0) {
        // Fri / Sat / Sun → ships Monday
        diff = getMondayCutoff(now) - now;
        shipText = 'shipped Monday';
      } else {
        const cutoffToday = new Date(now);
        cutoffToday.setHours(cutoffHour, cutoffMin, 0, 0);
        diff = cutoffToday - now;

        if (diff > 0) {
          // Before cutoff Mon–Thu → ships tomorrow
          shipText = 'shipped tomorrow';
        } else if (day === 4) {
          // Thursday after cutoff → day after tomorrow = Sat, so ships Monday
          diff = getMondayCutoff(now) - now;
          shipText = 'shipped Monday';
        } else {
          // Mon–Wed after cutoff → ships in 2 days
          const cutoffTomorrow = new Date(now);
          cutoffTomorrow.setDate(cutoffTomorrow.getDate() + 1);
          cutoffTomorrow.setHours(cutoffHour, cutoffMin, 0, 0);
          diff = cutoffTomorrow - now;
          shipText = 'shipped in 2 days';
        }
      }

      const hours   = Math.floor(diff / 3600000);
      const minutes = Math.floor((diff % 3600000) / 60000);
      const seconds = Math.floor((diff % 60000) / 1000);

      textEl.innerHTML = 'Get <strong>' + productName + '</strong> ' + shipText + ' if you order within ';
      timerEl.textContent =
        String(hours).padStart(2, '0')   + ' Hours ' +
        String(minutes).padStart(2, '0') + ' Minutes ' +
        String(seconds).padStart(2, '0') + ' Seconds';

      wrapper.style.display = 'block';
    }

    tick();
    intervals.set(wrapperId, setInterval(tick, 1000));
  }

  window.initShippingCountdowns = function () {
    document.querySelectorAll('[id^="shipping-countdown-wrapper-"]').forEach(function (wrapper) {
      initShippingCountdown(wrapper);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', window.initShippingCountdowns);
  } else {
    window.initShippingCountdowns();
  }
})();
